export default "/images/chevron-richmond.jpg";